export const SET_USER = "SET_USER";
export const SET_STATUS = "SET_STATUS";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SELECT_FACILITY = "SELECT_FACILITY";
export const GET_MY_FACILITIES = "GET_MY_FACILITIES";
export const GET_MY_DOCUMENTS = "GET_MY_DOCUMENTS";

export const GET_FACILITY = "GET_FACILITY";
export const ADD_FACILITY = "ADD_FACILITY";
export const EDIT_FACILITY = "EDIT_FACILITY";
export const DELETE_FACILITY = "DELETE_FACILITY";

export const GET_DOCUMENT_TYPES = "GET_DOCUMENT_TYPES";
